<template>
  <div class="home-wrapper">
    <header class="home-header">
      <button class="btn-login" @click="login()">Iniciar Sesión</button>
    </header>
    <main class="home-content">
      <CarrouselPrincipal />
    </main>
<!--  
  <div class="center">
    <input type="email" id="email" class="correo" placeholder="name@example.com" v-model="email">
    <button type="submit" class="btn btn-primary mb-3" @click="registrar()">Registrarse ></button>
    <br>
    <p class="mensaje">{{ mensaje }}</p>
  </div>
  <hr>
-->
  </div>
</template>

<script>
import CarrouselPrincipal from '../components/CarrouselPrincipal.vue'
export default {
  name: 'Home',
  components: { CarrouselPrincipal },
  methods: {
    login() {
      this.$router.push('Login')
    },
  }
}
</script>

<style scoped>
.home-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.home-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0.75rem 1.5rem;
  background: #ffffff;
  border-bottom: 1px solid #e9ecef;
}

.home-content {
  flex: 1;
  text-align: center;
}

.btn-login {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.55rem 1.25rem;
  background: #003d99;
  color: #ffffff;
  font-size: 0.95rem;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s, transform 0.1s, box-shadow 0.2s;
  box-shadow: 0 0 10px rgba(0, 61, 153, 0.35);
}

.btn-login:hover {
  background: #0059cc;
  box-shadow: 0 0 18px rgba(0, 89, 204, 0.55);
  transform: translateY(-2px);
}

.btn-login:active {
  transform: translateY(0);
}
</style>